import { gql, type OperationVariables } from '@apollo/client';
import { cloneDeep } from '@apollo/client/utilities';
import type { ISmallRole } from '@sharedInterfaces/IWhoIAm';
import { setEmployeeRoles } from '@store/reducer/employeeReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

const query = gql`
mutation changeMapRole($id: Int!, $add: Boolean!) {
    changeMapRole(id: $id, add: $add) 
},
`;

/**
 * Change the map role.
 *
 * @param {number} id - The ID of the role.
 * @param {boolean} add - Specifies whether to add or remove the role.
 * @returns {Promise<boolean>} A promise that resolves to a boolean indicating whether the role was successfully changed.
 */
export default async function changeMapRole(id: number, add: boolean) {
    const variables: OperationVariables = {
        id,
        add,
    };
    return GraphQL.mutate<boolean>(query, variables).then((result) => {
        const state = store.getState();
        if (add) {
            const allRole = state.company.allRoles.find((c) => c.id === id) as ISmallRole;

            const newRoles = cloneDeep(state.employee.roles.filter((c) => c.id !== id));
            newRoles.push({
                id: id,
                title: allRole.title,
            });
            store.dispatch(setEmployeeRoles(newRoles));
        } else {
            store.dispatch(setEmployeeRoles(state.employee.roles.filter((c) => c.id !== id)));
        }
        return result;
    });
}
